export const PARTNER_SEARCH_NAMESPACE = 'partnerSearch'

export const REQUEST_MORE_PARTNERS = `${PARTNER_SEARCH_NAMESPACE}/requestMorePartners`
export const REQUEST_MORE_CONTACTS = `${PARTNER_SEARCH_NAMESPACE}/requestMoreContacts`
